// Constant
export const GIFT_CARD_DEAL_ID = 2098;
export const GIFT_CARD_OUTLET_ID = 1057;
export const GIFT_CARD_CATEGORY_ID = 2;
export const CART_UPDATED_KEY = 'cart_updated';

export const PAYMENT_METHOD_DIRECT_BANK_DEPOSIT_ID = 1;
export const PAYMENT_METHOD_CASH_AND_POS_ID = 4;
export const PAYMENT_METHOD_INTERNET_BANKING_ID = 5;
export const PAYMENT_METHOD_MIPS_ID = 9;
export const PAYMENT_METHOD_PEACH_CHECKOUT_CC_ID = 13;
export const PAYMENT_METHOD_PEACH_CHECKOUT_JUICE_ID = 14;
